"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnPhone = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const ColumnPhone = () => {
    return {
        id: 'phone',
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Phone:Title', defaultMessage: 'Phone' })),
        Cell: ({ row }) => {
            var _a;
            return (react_1.default.createElement(react_1.default.Fragment, null, (_a = row.original.phones) === null || _a === void 0 ? void 0 : _a.map((phone, idx) => react_1.default.createElement("div", { key: idx }, phone))));
        },
    };
};
exports.ColumnPhone = ColumnPhone;
//# sourceMappingURL=index.js.map